<sl-paged-grid #grid [config]="gridConfig" />
